



















































































import {
  defineComponent,
  reactive,
  computed,
  ref,
  onMounted,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import {
  getMaterial,
  getMaterialPurchaseHistories,
  getMaterialUsageHistories,
} from '@/api';

import purchaseHistoryTableOption from '@/table/Store/material-purchase-history';
import materialUsageTableOption from '@/table/Store/material-usage';
import useAuth from '@/use/useAuth';

const MaterialDetail = defineComponent({
  setup(props, { root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const { route } = useRouter();
    const refetchQuery = ref(false);
    const currentTab = ref('purchase');
    const pendingSearch = _.debounce(() => { refetchQuery.value = true; }, 250);
    const toCurrency = (amount: number) => parseFloat(`${amount}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    const usagePermission = computed(() => hasPermission('materials.usageHistory'));
    const poPermission = computed(() => hasPermission('materials.poHistory'));

    const material = ref({
      id: -1,
      name: '',
      code: '',
      amount: 0,
    });
    const filter = reactive({
      searchLot: '',
      searchPurchaseOrder: '',
      searchWithdrawRequest: '',
      searchBomItem: '',
      date: '',
      // date: {
      //   from: undefined,
      //   to: undefined,
      // },
    });
    const computedFilter = computed(() => {
      if (currentTab.value === 'purchase') {
        return {
          searchLot: filter.searchLot,
          searchPurchaseOrder: filter.searchPurchaseOrder,
          date: filter.date,
        };
      }
      return {
        searchWithdrawRequest: filter.searchWithdrawRequest,
        searchBomItem: filter.searchBomItem,
        date: filter.date,
      };
    });
    function tabChangeHandler(tabName: string) {
      currentTab.value = tabName;
      filter.date = '';
      pendingSearch();
    }

    const latestPrice = ref(-0);
    function getLastedPrice(queryResult: any) {
      latestPrice.value = queryResult.latest_price;
    }

    onMounted(async () => {
      material.value = (await getMaterial(route.value.params.id)).data;
    });

    return {
      tabChangeHandler,
      usagePermission,
      poPermission,

      material,
      pendingSearch,
      refetchQuery,
      toCurrency,

      latestPrice,
      getLastedPrice,

      filter,
      computedFilter,
      getMaterialPurchaseHistories,
      purchaseHistoryTableOption,

      getMaterialUsageHistories,
      materialUsageTableOption,
    };
  },
});

export default MaterialDetail;
